import { AutoInitializable } from "@zupper/data";

export class ZupperSocialMedia extends AutoInitializable {
  name: string;
  url: string;
  icon?: string;
  iconUrl?: string;
}
